import { z } from 'zod'

export const changePasswordFormSchema = z
  .object({
    currentPassword: z.string(),
    newPassword: z.string(),
    newPasswordConfirm: z.string(),
  })
  .superRefine(({ currentPassword, newPassword, newPasswordConfirm }, ctx) => {
    if (!currentPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please enter current password.',
        path: ['currentPassword'],
      })
    }

    if (!newPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please enter new password.',
        path: ['newPassword'],
      })
    }

    if (!newPasswordConfirm) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please enter confirmation password.',
        path: ['newPasswordConfirm'],
      })
    }

    if (newPassword && newPasswordConfirm && newPassword !== newPasswordConfirm) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'The new password and the confirmation password must match.',
        path: ['newPasswordConfirm'],
      })
    }
  })
